import { Injectable, Type } from '@angular/core';
import { FlowAbstractNodeComponent } from '../components';
import { FLOW_NODE_MAP } from '../constants/node-map.constants';
import { FlowNodeType } from '../enums';
import { FlowNode } from '../models';

@Injectable({ providedIn: 'root' })
export class FlowNodeComponentRegistry {
  register(nodeType: FlowNodeType, componentRef: Type<FlowAbstractNodeComponent<FlowNode, any>>, params?: Partial<{
    name: string;
    icon: string;
    color: string;
    root?: boolean;
    order: number;
  }>): void {
    const nodeConfig = FLOW_NODE_MAP[nodeType];
    FLOW_NODE_MAP[nodeType] = { ...nodeConfig, ...params, componentRef };
  }

  resolve(nodeType: FlowNodeType): Type<any> | undefined {
    return FLOW_NODE_MAP[nodeType]?.componentRef;
  }
}
